import React from 'react';
import { Alert } from '../../../../../CommonComponents/OPL/Alert/Alert';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalType } from '../ManagementStyleToggle/ManagamentStyleToggle.meta';

interface Props {
  isOpen: ModalType | null;
  onClose(): void;
  isLoading: boolean;
  isError: boolean;
  onSave(): void;
}

export const OrionManagementStyleModal = ({
  isOpen,
  onClose,
  isLoading,
  isError,
  onSave,
}: Props) => {
  return (
    <Modal isOpen={isOpen !== null} onRequestClose={onClose} aria={{ labelledby: 'modal-header' }}>
      <ModalHeader as="h2" id="modal-header">
        {isOpen === ModalType.UseOrionManagementStyleModal
          ? 'Use Orion Management Style?'
          : 'Use Default Style?'}
      </ModalHeader>

      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        {isError && (
          <Alert
            message="There was an error processing your request. Please try again. "
            variant="error"
            mb="16"
          />
        )}

        {isOpen === ModalType.UseOrionManagementStyleModal
          ? `By selecting this option, this will replace the Orion Planning account types with your firm’s Orion management styles for assigning to buckets.`
          : `By selecting this option, this will revert back to the Orion Planning account types for assigning to buckets.`}
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button ml="8" isLoading={isLoading} onClick={onSave}>
          OK
        </Button>
      </ModalFooter>
    </Modal>
  );
};
